import useMediaQuery from "@mui/material/useMediaQuery";

/**
 * Compact UI trigger for short "720p" customer machines.
 *
 * Tested targets are short screens: 1280x650, 1024x600, and 1366x768 laptops
 * (whose usable viewport height drops to ~700px once browser chrome is added).
 *
 * The trigger is HEIGHT-ONLY (<=720px tall). Compact mode is about fitting more
 * content vertically on a short screen, so width is irrelevant — and a width
 * trigger (e.g. <=1366px) wrongly fires on ordinary laptops and any non-maximized
 * browser window. Normal-height screens (>=768px tall) stay byte-identical.
 */
export const COMPACT_QUERY = "(max-height:720px)";

/**
 * Narrow-width trigger for fluid fitting (separate concern from COMPACT_QUERY).
 *
 * SaleSummary / ProfitAndCost each have a two-column internal layout (cards +
 * pie chart, or two number cards). Whether they sit in the 6-of-12 slot
 * (small-screen 12/6/6 dashboard) or the 5-of-12 right column (wide-screen 7/5
 * dashboard), the card is too narrow for its internal columns at <=1280px, so we
 * stack the internals into one column there (matching the dashboard's 12/6/6
 * switch at the same width). Above 1280px they sit side-by-side; SalePieChart
 * shrinks its own pie/legend in the 1281-1453px band where the 5-of-12 right
 * column is still tight.
 */
export const NARROW_QUERY = "(max-width:1280px)";

export function useCompact(): boolean {
  return useMediaQuery(COMPACT_QUERY, { noSsr: true });
}
